module.exports = __webpack_public_path__ + "img/4-1_04.cbe786d8.jpg";